(function() { window.GUID_7f285942_ceba_40ea_8856_cf589337c536 = { getGuid: function() { return "7f285942-ceba-40ea-8856-cf589337c536"; } }; })();
//TODO:POP
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        var ImageCropperAddons;
        (function (ImageCropperAddons) {
            /**
             * image-cropper inside the popup (It create the popup)
             */
            class ImageCropperPopup extends ImageCropperAddons.Base {
                OnDispose() {
                    this.removeEventsBindings();
                }
                constructor(helper) {
                    super(helper);
                    //private maxOutputImageWidth: number = 1200;
                    //private maxOutputImageHeight: number = 1200;
                    //Différent sur CS.Web et sur CS.APP
                    this.uploadUrl = () => {
                        return CS.Url.CSUrl("imagecropperuploadv2");
                    };
                    this.MinSizeRestrictionEnabled = true;
                    this.cropperNameSpace = "imagecropper";
                    this.mouseDown = false;
                    this.scaleVelocity = 0.03;
                    this.bothLoaded = false;
                    this.isPosting = false;
                    this.onKeyDown = (e) => {
                        let me = this;
                        let scaleVelocity = this.getScaleFactor();
                        switch (e.keyCode) {
                            case CS.Enums.KeyCode.Plus:
                                me.zoomImage(scaleVelocity);
                                break;
                            case CS.Enums.KeyCode.Subtract:
                                me.zoomImage(-scaleVelocity);
                                break;
                            case CS.Enums.KeyCode.ArrowUp:
                                this.moveImage(0, -1);
                                break;
                            case CS.Enums.KeyCode.ArrowDown:
                                this.moveImage(0, 1);
                                break;
                            case CS.Enums.KeyCode.ArrowLeft:
                                this.moveImage(-1, 0);
                                break;
                            case CS.Enums.KeyCode.ArrowRight:
                                this.moveImage(1, 0);
                                break;
                        }
                    };
                }
                isLocalUrl(url) {
                    if (!url)
                        return false;
                    // Check for relative URLs starting with /
                    if (url.charAt(0) === '/') {
                        // Make sure it's not a protocol-relative URL like //evil.com
                        if (url.length === 1 || (url.charAt(1) !== '/' && url.charAt(1) !== '\\')) {
                            return true;
                        }
                        return false;
                    }
                    // Check for URLs starting with ~/
                    if (url.charAt(0) === '~' && url.length > 1 && url.charAt(1) === '/') {
                        return true;
                    }
                    return false;
                }
                getProxyUrl(originalUrl) {
                    if (originalUrl.startsWith('blob:') || originalUrl.startsWith('data:')) {
                        return originalUrl;
                    }
                    // Uploaded images may use a storage-relative path rather than a root-relative URL.
                    const normalizedUrl = originalUrl.startsWith('cdn/') ? '/' + originalUrl : originalUrl.replace(/^~\//, '/');
                    let resolvedUrl;
                    try {
                        resolvedUrl = new URL(normalizedUrl, window.location.href);
                    }
                    catch (_a) {
                        return `/gallery/proxyimage?url=${encodeURIComponent(originalUrl)}`;
                    }
                    if (resolvedUrl.origin === window.location.origin) {
                        // HTMLImageElement.src becomes absolute. Do not proxy the proxy again during export.
                        if (resolvedUrl.pathname.toLowerCase() === '/gallery/proxyimage') {
                            return resolvedUrl.pathname + resolvedUrl.search;
                        }
                        // /cdn redirects to storage. Download through the proxy to keep the canvas origin-clean.
                        if (resolvedUrl.pathname.startsWith('/cdn/')) {
                            return `/gallery/proxyimage?url=${encodeURIComponent(resolvedUrl.pathname.substring(1))}`;
                        }
                        return resolvedUrl.href;
                    }
                    return `/gallery/proxyimage?url=${encodeURIComponent(originalUrl)}`;
                }
                Show(url, overlayUrl, imageCroppedCallback, croppingSize) {
                    // Remove the CORS capability check since we'll proxy external URLs
                    let me = this;
                    this.overlayUrl = overlayUrl;
                    me.imageCroppedCallback = imageCroppedCallback;
                    this.croppingSizeOriginal = croppingSize;
                    CS.Helper.log('ImageCropper', "Showing " + url);
                    this.createCropperHtml(url, this.overlayUrl, () => {
                        this.croppingSize = ImageCropperPopup.SetSizeBasedOnContainedImage(this.$ImageCropperCropSpace, this.croppingSizeOriginal);
                        ImageCropperPopup.SetSizeBasedOnContainedImage(this.imageToCrop.$Img);
                        this.bindEvents();
                        this.fitContainer();
                        this.$imageCropper.show();
                        this.fitImageToCrop();
                        CS.DOM.$body.addClass("noScroll");
                    });
                }
                fitContainer() {
                    var space = ImageCropperPopup.FitElement(this.$ImageCropperCropSpace, this.innerPadding, this.$imageCropper);
                    CS.Lag(this.cropperNameSpace + "-fit-container", 1, () => {
                        var position = this.$ImageCropperCropSpace.position();
                        var realPosition = {
                            X: position.left + space.margin.left,
                            Y: position.top + space.margin.top,
                        };
                        //space.position = this.getRealPosition(this.$ImageCropperCropSpace);
                        this.overflowOpacity.Top.css({
                            top: 0 - this.innerPadding,
                            left: 0 - this.innerPadding,
                            right: 0 - this.innerPadding,
                            height: realPosition.Y + this.innerPadding,
                        });
                        this.overflowOpacity.Left.css({
                            left: 0 - this.innerPadding,
                            top: realPosition.Y,
                            height: space.size.Height,
                            width: realPosition.X + this.innerPadding,
                        });
                        this.overflowOpacity.Right.css({
                            top: realPosition.Y,
                            left: realPosition.X + space.size.Width,
                            height: space.size.Height,
                            right: 0 - this.innerPadding,
                        });
                        this.overflowOpacity.Bottom.css({
                            left: 0 - this.innerPadding,
                            top: realPosition.Y + space.size.Height,
                            right: 0 - this.innerPadding,
                            bottom: 0 - this.innerPadding,
                        });
                    });
                }
                createCropperHtml(url, overlayUrl, callback) {
                    let me = this;
                    let containOverlay = overlayUrl != null && overlayUrl != "";
                    this.bothLoaded = !containOverlay;
                    let overFlowDiv = () => {
                        return $("<div></div>").addClass("image-cropper-overflow-oppacity");
                    };
                    this.$imageCropper = $('<div class="image-cropper"></div>');
                    this.$imageCropperInner = $('<div class="inner"></div>');
                    this.$imageCropper.append(this.$imageCropperInner);
                    let $overlayCornerBordersElement = $(`
                <div class="image-cropper-overlay-corner-borders"></div>
            `);
                    let $topBar = $(`
                <div class="image-cropper__top-bar"></div>
            `);
                    let $bottomBar = $(`
                <div class="image-cropper__bottom-bar"></div>
            `);
                    let $topBarColLeft = $(`
                <div class="col"></div>
            `);
                    let $topBarColRight = $(`
                <div class="col"></div>
            `);
                    let $bottomBarColLeft = $(`
                <div class="col"></div>
            `);
                    let $bottomBarColRight = $(`
                <div class="col"></div>
            `);
                    this.overflowOpacity = {
                        Bottom: overFlowDiv(),
                        Left: overFlowDiv(),
                        Right: overFlowDiv(),
                        Top: overFlowDiv(),
                    };
                    this.$ImageCropperCropSpace = $('<div class="image-cropper-cropspace"></div>');
                    this.$fitButton = $(`
                <button class="button button--big csico btn-cropper btn-fit" style="z-index: 9999;">
                    <div class="icon ic-cs-expand"></div>
                </button> 
            `);
                    this.$closeButton = $(`
                <button class="button button--big csico btn-cropper cs-btn-close" style="z-index: 9999;">
                    <div class="icon ic-cs-arrow-left"></div>
                </button>
            `);
                    this.$okButton = $(`
                <button class="button button--big button--secondary btn-cropper btn-ok" style="z-index: 9999;">
                    ${Controls.ImageCropper.Ress.Save()}
                </button>
            `);
                    this.$openWebcamButton = $(`
                <button class="button button--big csico btn-cropper btn-webcam" style="z-index: 9999;">
                    <div class="icon ic-cs-camera"></div>
                </button>
            `);
                    this.$openFileButton = $(`
                <button class="button button--big csico btn-cropper btn-file" style="z-index: 9999;">
                    <div class="icon ic-cs-picture"></div>
                </button>
            `);
                    $topBarColLeft.append(this.$closeButton);
                    this.$btnCropperGroup = $("<div></div>").addClass("btn-cropper-group");
                    if (this.mainHelper.IsWebcamSupported().IsSupported)
                        $bottomBarColLeft.append([
                            this.$openWebcamButton,
                            this.$openFileButton,
                        ]);
                    else
                        $bottomBarColLeft.append(this.$openFileButton);
                    $bottomBarColLeft.append(this.$fitButton);
                    $bottomBarColRight.append(this.$okButton);
                    const imageToCrop = $('<img class="image-to-crop" draggable="false">');
                    const imgEl = imageToCrop[0];
                    // Use proxy URL for external images
                    const proxiedUrl = this.getProxyUrl(url);
                    // Only set crossOrigin for non-proxied external URLs (which shouldn't happen now)
                    if (proxiedUrl === url && !this.isLocalUrl(url) && !url.startsWith('blob:') && !url.startsWith('data:')) {
                        imgEl.crossOrigin = 'anonymous';
                    }
                    imageToCrop.on("load", function () {
                        if (me.bothLoaded || !containOverlay) {
                            callback.call(this);
                            me.imageToCrop.ImageLoaded();
                        }
                        me.bothLoaded = true;
                    });
                    imageToCrop.on("error", () => this.showImageLoadError());
                    this.$imageOverlayContainer = $('<div class="image-cropper-overlay-container"></div>');
                    this.$ImageCropperCropSpace.append(imageToCrop);
                    this.$ImageCropperCropSpace.append($overlayCornerBordersElement);
                    this.$ImageCropperCropSpace.append(this.$imageOverlayContainer);
                    this.$imageCropperInner.append(this.$ImageCropperCropSpace);
                    this.$imageCropperInner.append([
                        this.overflowOpacity.Bottom,
                        this.overflowOpacity.Left,
                        this.overflowOpacity.Right,
                        this.overflowOpacity.Top,
                    ]);
                    $topBar.append([$topBarColLeft, $topBarColRight]);
                    $bottomBar.append([$bottomBarColLeft, $bottomBarColRight]);
                    this.$imageCropperInner.append($topBar);
                    this.$imageCropperInner.append($bottomBar);
                    this.imageToCrop = new ImageToCrop(imageToCrop, this.$imageOverlayContainer, this.MinSizeRestrictionEnabled);
                    CS.DOM.$body.append(this.$imageCropper);
                    this.innerPadding =
                        parseInt(this.$imageCropperInner.css("left").replace("px", "")) + 7; //Le 7 correspond au padding du Body + un border de 2px;
                    if (containOverlay) {
                        const imgOverlay = $('<img class="image-overlay" draggable="false">');
                        const overlayEl = imgOverlay[0];
                        const proxiedOverlayUrl = this.getProxyUrl(overlayUrl);
                        // Only set crossOrigin for non-proxied external URLs
                        if (proxiedOverlayUrl === overlayUrl && !this.isLocalUrl(overlayUrl) && !overlayUrl.startsWith('blob:') && !overlayUrl.startsWith('data:')) {
                            overlayEl.crossOrigin = 'anonymous';
                        }
                        imgOverlay.on("load", function () {
                            if (me.bothLoaded) {
                                callback.call(this);
                                me.imageToCrop.ImageLoaded();
                            }
                            me.bothLoaded = true;
                        });
                        imgOverlay.on("error", () => this.showImageLoadError());
                        this.$imageOverlayContainer.append(imgOverlay);
                        overlayEl.src = proxiedOverlayUrl;
                    }
                    imgEl.src = proxiedUrl;
                }
                showImageLoadError() {
                    if (!this.$imageCropper || this.$imageCropper.hasClass("image-cropper--load-error"))
                        return;
                    this.$imageCropper.find("img").off("load error");
                    this.$okButton.prop("disabled", true);
                    this.$fitButton.prop("disabled", true);
                    this.$imageCropper.addClass("image-cropper--load-error");
                    this.$imageCropperInner.append($('<div class="image-cropper__error" role="alert"></div>').text(CS.Lang("This image could not be loaded. Choose a file or take a new photo.", "Impossible de charger cette image. Choisissez un fichier ou prenez une nouvelle photo.")));
                    this.bindNavigationButtons();
                    this.$imageCropper.show();
                    CS.DOM.$body.addClass("noScroll");
                }
                Close(response) {
                    let me = this;
                    CS.DOM.$body.removeClass("noScroll");
                    me.removeEventsBindings();
                    // Revoke only if we used a blob/object URL
                    const url = this.imageToCrop.ImgHtml.src || "";
                    if (typeof url === 'string' && url.startsWith('blob:')) {
                        URL.revokeObjectURL(url);
                    }
                    if (me.$imageCropper != null) {
                        me.$imageCropper.find("img").off("load error");
                        me.$imageCropper.remove();
                        me.$imageCropper = null;
                        if (response != null)
                            me.imageCroppedCallback.call(this, response);
                    }
                }
                bindNavigationButtons() {
                    this.$closeButton.offon("click." + this.cropperNameSpace, () => {
                        this.Close(null);
                    });
                    this.$openFileButton.offon("click." + this.cropperNameSpace, () => {
                        this.Close();
                        this.mainHelper.OpenFile();
                    });
                    this.$openWebcamButton.offon("click." + this.cropperNameSpace, () => {
                        this.Close();
                        this.mainHelper.OpenWebcam();
                    });
                }
                bindEvents() {
                    let me = this;
                    this.bindNavigationButtons();
                    this.$okButton.offon("click." + this.cropperNameSpace, () => {
                        if (!this.isPosting) {
                            this.isPosting = true;
                            CS.Lag("Image-Cropper-okButton", 250, () => {
                                me.drawOnCanvasAndSendToServer((response) => {
                                    this.isPosting = false;
                                    me.Close(response);
                                });
                            });
                        }
                    });
                    this.$fitButton.offon("click." + this.cropperNameSpace, function () {
                        me.fitImageToCrop();
                    });
                    CS.DOM.$doc
                        .offon("mousedown." + this.cropperNameSpace, (e) => this.onMouseDown(e))
                        .offon("mouseup." + this.cropperNameSpace, (e) => this.onMouseUp(e))
                        .offon("mousemove." + this.cropperNameSpace, (e) => this.onMouseMove(e))
                        .offon("DOMMouseScroll." + this.cropperNameSpace, (e) => this.onMouseWheel(e))
                        .offon("mousewheel." + this.cropperNameSpace, (e) => this.onMouseWheel(e))
                        .offon("keydown." + this.cropperNameSpace, (e) => this.onKeyDown(e));
                    CS.DOM.$win.offon("resize." + this.cropperNameSpace, (e) => this.onResize(e));
                    if (CS.Controls.ImageCropperAddons.ImageCropperMobile) {
                        this.mobileHelper =
                            new CS.Controls.ImageCropperAddons.ImageCropperMobile(this.mainHelper, window, this.$imageOverlayContainer[0], (scale, center) => {
                                this.zoomImage(0.3 * scale, center);
                                //console.debug("Scale: " + scale);
                            }, {
                                DragEndCallback: () => {
                                    this.imageToCrop.SaveCurrentPosition(true);
                                },
                                DragStartCallback: () => {
                                    this.imageToCrop.SaveCurrentPosition();
                                },
                                MoveCallback: (move) => {
                                    //Animation frame is allready handled inside ImageCropperMobile
                                    this.imageToCrop.SetNewPosition(move, false);
                                },
                            });
                    }
                    if (CS.PullToRefresh.Current) {
                        CS.PullToRefresh.Current.Desactivate();
                    }
                }
                removeEventsBindings() {
                    CS.DOM.$doc
                        .off("mousedown." + this.cropperNameSpace)
                        .off("mouseup." + this.cropperNameSpace)
                        .off("mousemove." + this.cropperNameSpace)
                        .off("DOMMouseScroll." + this.cropperNameSpace)
                        .off("mousewheel." + this.cropperNameSpace)
                        .off("keydown." + this.cropperNameSpace);
                    CS.DOM.$win.off("resize." + this.cropperNameSpace);
                    if (this.$closeButton)
                        this.$closeButton.off("click." + this.cropperNameSpace);
                    if (this.$okButton)
                        this.$okButton.off("click." + this.cropperNameSpace);
                    if (this.$fitButton)
                        this.$fitButton.off("click." + this.cropperNameSpace);
                    if (this.$openFileButton)
                        this.$openFileButton.off("click." + this.cropperNameSpace);
                    if (this.$openWebcamButton)
                        this.$openWebcamButton.off("click." + this.cropperNameSpace);
                }
                drawOnCanvasAndSendToServer(callback) {
                    let me = this;
                    let srcX, srcY, destX = 0, destY = 0;
                    let imgHtml = this.imageToCrop.ImgHtml;
                    let canvas = document.createElement("canvas");
                    var ctx = canvas.getContext("2d");
                    let src = this.imageToCrop.$Img;
                    let dest = this.$ImageCropperCropSpace;
                    let srcPos = this.getRealPosition(src);
                    let destPos = { X: 0, Y: 0 }; //this.getRealPosition(dest);
                    let canvasSize = ImageCropperPopup.GetImageOriginalSize(dest);
                    let srcSize = ImageCropperPopup.GetImageOriginalSize(src);
                    let srcScale = src.data("scale");
                    let destScale = dest.data("scale");
                    let resolutionScale = 1;
                    let finalScale = (srcScale / destScale) * resolutionScale;
                    let destSize = new CS.Size(srcSize.Width * finalScale, srcSize.Height * finalScale);
                    canvasSize.Width = canvasSize.Width * resolutionScale;
                    canvasSize.Height = canvasSize.Height * resolutionScale;
                    ctx.clearRect(0, 0, canvasSize.Width, canvasSize.Height);
                    ctx.canvas.width = canvasSize.Width;
                    ctx.canvas.height = canvasSize.Height;
                    srcX = (destPos.X - srcPos.X) / srcScale;
                    srcY = (destPos.Y - srcPos.Y) / srcScale;
                    if (srcX < 0) {
                        destX = Math.abs(srcX * finalScale);
                        srcX = 0;
                    }
                    if (srcY < 0) {
                        destY = Math.abs(srcY * finalScale);
                        srcY = 0;
                    }
                    ctx.drawImage(imgHtml, srcX, srcY, srcSize.Width, srcSize.Height, destX, destY, destSize.Width, destSize.Height);
                    me.sendCanvasImageToServer(canvas, callback);
                }
                getRealPosition(element) {
                    let marginLeft = parseFloat(element.css("margin-left").replace("px", ""));
                    let marginTop = parseFloat(element.css("margin-top").replace("px", ""));
                    let position = element.position();
                    return {
                        X: position.left + marginLeft,
                        Y: position.top + marginTop,
                    };
                }
                sendCanvasImageToServer(_canvas, callback) {
                    const src = this.imageToCrop.$Img;
                    const imgEl = this.imageToCrop.ImgHtml;
                    // ---- compute sizes just like before ----
                    const dest = this.$ImageCropperCropSpace;
                    const srcPos = this.getRealPosition(src);
                    const destPos = { X: 0, Y: 0 };
                    const canvasSize = ImageCropperPopup.GetImageOriginalSize(dest);
                    const srcSize = ImageCropperPopup.GetImageOriginalSize(src);
                    const srcScale = src.data("scale");
                    const destScale = dest.data("scale");
                    const resolutionScale = 1;
                    const finalScale = (srcScale / destScale) * resolutionScale;
                    let srcX = (destPos.X - srcPos.X) / srcScale;
                    let srcY = (destPos.Y - srcPos.Y) / srcScale;
                    let destX = 0, destY = 0;
                    if (srcX < 0) {
                        destX = Math.abs(srcX * finalScale);
                        srcX = 0;
                    }
                    if (srcY < 0) {
                        destY = Math.abs(srcY * finalScale);
                        srcY = 0;
                    }
                    const destSize = new CS.Size(srcSize.Width * finalScale, srcSize.Height * finalScale);
                    // ---- build canvas ----
                    const canvas = document.createElement("canvas");
                    const ctx = canvas.getContext("2d");
                    ctx.canvas.width = canvasSize.Width * resolutionScale;
                    ctx.canvas.height = canvasSize.Height * resolutionScale;
                    // ---- load a CLEAN image depending on URL scheme ----
                    const originalUrl = imgEl.src || '';
                    const proxiedUrl = this.getProxyUrl(originalUrl);
                    const clean = new Image();
                    clean.onload = () => {
                        ctx.drawImage(clean, srcX, srcY, srcSize.Width, srcSize.Height, destX, destY, destSize.Width, destSize.Height);
                        const dataUrl = canvas.toDataURL("image/jpeg", 0.7);
                        let imageType = null;
                        if (this.mainHelper.Params && typeof this.mainHelper.Params.ImageType === "string") {
                            imageType = this.mainHelper.Params.ImageType;
                        }
                        const data = {
                            DataImage: dataUrl.replace("data:image/jpeg;base64,", ""),
                            OverlayUrl: this.overlayUrl,
                            ImageType: imageType,
                            SaveOverlay: this.mainHelper.Params.SaveOverlay == true,
                            SportEventId: this.mainHelper.Params.SportEventId,
                            EntityId: this.mainHelper.Params.EntityId,
                        };
                        if (!data.DataImage) {
                            console.error("Image cropper generated an empty upload payload.");
                            this.isPosting = false;
                            return;
                        }
                        const postAction = CS.Ajax.Post(this.uploadUrl(), data, (response) => {
                            callback.call(this, response);
                        }, (param) => { param.makeUIReadOnly = true; });
                        postAction.always(() => { this.isPosting = false; });
                    };
                    clean.onerror = () => {
                        console.error("Failed to load export image:", originalUrl);
                        this.isPosting = false;
                    };
                    // Use proxy URL for the clean image load
                    if (proxiedUrl !== originalUrl) {
                        // Proxied image - no need for crossOrigin or cache busting
                        clean.src = proxiedUrl;
                    }
                    else {
                        // Original logic for blob/data URLs
                        const isBlobOrData = originalUrl.startsWith('blob:') || originalUrl.startsWith('data:');
                        if (isBlobOrData) {
                            clean.src = originalUrl;
                        }
                        else {
                            clean.crossOrigin = 'anonymous';
                            const bust = (originalUrl.includes('?') ? '&' : '?') + 'corsfix=' + Date.now();
                            clean.src = originalUrl + bust;
                        }
                    }
                }
                onMouseDown(e) {
                    if (e.target.tagName == "BUTTON" || e.target.tagName == "A") {
                        return;
                    }
                    this.mouseDown = true;
                    this.imageToCrop.SaveCurrentPosition();
                    this.startPosition = { X: e.pageX, Y: e.pageY };
                }
                onMouseUp(e) {
                    this.mouseDown = false;
                    this.imageToCrop.SaveCurrentPosition(true);
                }
                onMouseMove(e) {
                    if (e.buttons == 0)
                        this.mouseDown = false;
                    if (this.mouseDown) {
                        this.imageToCrop.SetNewPosition(this.calculateDeltaPosition(e));
                    }
                }
                onMouseWheel(e) {
                    let event = e.originalEvent;
                    let wheelVal = event.detail || -(event.wheelDelta / 120);
                    let scaleVelocity = this.getScaleFactor();
                    this.zoomImage(-wheelVal * scaleVelocity);
                }
                onResize(e) {
                    this.fitContainer();
                }
                zoomImage(delta, center) {
                    let newScale = this.imageToCrop.$Img.data("scale") + delta;
                    this.imageToCrop.Scale(newScale, center);
                    ImageCropperPopup.SaveScale(this.imageToCrop.$Img);
                    this.imageToCrop.SaveCurrentPosition(true);
                }
                moveImage(x, y) {
                    this.imageToCrop.SaveCurrentPosition();
                    this.imageToCrop.SetNewPosition({ X: x, Y: y });
                    this.imageToCrop.SaveCurrentPosition();
                }
                static SetSizeBasedOnContainedImage(element, croppingSize) {
                    let size;
                    if (croppingSize != null) {
                        size = croppingSize;
                    }
                    else {
                        size = ImageCropperPopup.GetImageOriginalSize(element);
                    }
                    element.css({
                        width: size.Width + "px",
                        height: size.Height + "px",
                    });
                    element.data("aspect-ratio", size.Width / size.Height);
                    element.data("img-original-size", size);
                    return size;
                }
                calculateDeltaPosition(e) {
                    let currentPosition = { X: e.pageX, Y: e.pageY };
                    let delta = {
                        X: currentPosition.X - this.startPosition.X,
                        Y: currentPosition.Y - this.startPosition.Y,
                    };
                    return delta;
                }
                fitImageToCrop() {
                    this.imageToCrop.SaveOriginalSize();
                    this.imageToCrop.SaveMinSize();
                    this.imageToCrop.Fit();
                    //ImageCropper.FitElement(this.imageToCrop.$Img, this.innerPadding, this.$imageCropper);
                }
                static FitElement(element, innerPadding, container) {
                    let scale, width, height, marginLeft, marginTop;
                    let bodyLimits = ImageCropperPopup.GetBodyLimits(innerPadding, container);
                    let ratioX = bodyLimits.Width / element.outerWidth();
                    let ratioY = bodyLimits.Height / element.outerHeight();
                    let aspectRatio = element.data("aspect-ratio");
                    if (ratioX < ratioY) {
                        //body portrait
                        scale = ratioX;
                        width = bodyLimits.Width;
                        height = width / aspectRatio;
                    }
                    else {
                        //body landscape
                        scale = ratioY;
                        height = bodyLimits.Height;
                        width = height * aspectRatio;
                    }
                    marginLeft = -(width / 2);
                    marginTop = -(height / 2);
                    element.css({
                        width: width + "px",
                        height: height + "px",
                        left: "50%",
                        top: "50%",
                        marginLeft: marginLeft + "px",
                        marginTop: marginTop + "px",
                    });
                    this.SaveScale(element);
                    return {
                        size: new CS.Size(width, height),
                        margin: { top: marginTop, left: marginLeft },
                    };
                }
                static GetBodyLimits(innerPadding, container) {
                    let body = container != null ? container : CS.DOM.$body;
                    return new CS.Size(body.outerWidth() - innerPadding, body.outerHeight() - innerPadding);
                }
                /**
                 * Get the minimum size of the image inside the container
                 * @param image
                 * @param container
                 * @param fillContainer
                 * true: Fill container, image will crop. false: all the image will be show inside the container
                 */
                static GetMinImageSize(image, container, fillContainer = true) {
                    let imageSize = this.GetImageOriginalSize(image);
                    let containerSize = new CS.Size(container.outerWidth(), container.outerHeight());
                    return this.GetMinSize(imageSize, containerSize, fillContainer);
                }
                /**
                 * Get the minimum size of the content inside the container
                 * @param contentSize
                 * @param containerSize
                 * @param fillContainer
                 * true: Fill container, content will crop. false: all the content will be show inside the container
                 */
                static GetMinSize(contentSize, containerSize, fillContainer = true) {
                    // Figure out the ratio
                    let ratio = 1;
                    if (containerSize) {
                        let ratioX = containerSize.Width / contentSize.Width;
                        let ratioY = containerSize.Height / contentSize.Height;
                        if (fillContainer) {
                            // use whichever multiplier is bigger
                            ratio = ratioX > ratioY ? ratioX : ratioY;
                        }
                        else {
                            // use whichever multiplier is smaller
                            ratio = ratioX < ratioY ? ratioX : ratioY;
                        }
                    }
                    // now we can get the new height and width
                    let newHeight = Math.round(contentSize.Height * ratio);
                    let newWidth = Math.round(contentSize.Width * ratio);
                    return new CS.Size(newWidth, newHeight);
                }
                static FitToContainer(image, container) { }
                static SaveScale(element) {
                    let origSize = this.GetImageOriginalSize(element);
                    let currentScale = element.width() / origSize.Width;
                    element.data("scale", currentScale);
                }
                static GetImageOriginalSize(element) {
                    if (element.data("img-original-size") != null) {
                        let current = element.data("img-original-size");
                        return new CS.Size(current.Width, current.Height);
                    }
                    let img;
                    if (element[0].tagName == "IMG") {
                        img = element;
                    }
                    else {
                        img = element.find("img");
                    }
                    let imgHtml = img[0];
                    if (imgHtml == null) {
                        return new CS.Size(CS.DOM.$body.innerWidth(), CS.DOM.$body.innerHeight());
                    }
                    let width = imgHtml.naturalWidth;
                    let height = imgHtml.naturalHeight;
                    return new CS.Size(width, height);
                }
                getScaleFactor() {
                    return this.scaleVelocity * this.imageToCrop.$Img.data("scale");
                }
            }
            ImageCropperAddons.ImageCropperPopup = ImageCropperPopup;
            class ImageToCrop {
                constructor(img, container, minSizeRestrictionEnabled) {
                    this.MinSizeRestrictionEnabled = true;
                    this.inAnimation = false;
                    this.$Img = img;
                    this.ImgHtml = img[0];
                    this.MinSizeRestrictionEnabled = minSizeRestrictionEnabled;
                    this.container = container;
                }
                ImageLoaded() {
                    this.SaveCurrentPosition();
                    this.Fit();
                }
                /**
                 * Set the image possition
                 * @param position
                 * position in JQueryCoordinates or Position type
                 * @param saveCurrentPosition
                 * save the position in the 'currentPosition' varriable. Used with delta move. Default: true
                 */
                setImagePosition(position, saveCurrentPosition = true) {
                    let pos = new CS.Point(position);
                    this.$Img.css(pos.ToJQueryCoordinates());
                    if (saveCurrentPosition)
                        this.currentPosition = pos;
                }
                getMinPositions() {
                    return {
                        Y: this.ContainerSize.Height - this.CurrentSize.Height,
                        X: this.ContainerSize.Width - this.CurrentSize.Width,
                    };
                }
                validateSize() {
                    if (this.MinSizeRestrictionEnabled) {
                        this.SaveMinSize();
                        if (this.MinSize.Height > this.$Img.height() ||
                            this.MinSize.Width > this.$Img.width())
                            this.Fit();
                    }
                }
                validateNewPosition(position) {
                    let Y = position.Y;
                    let X = position.X;
                    if (this.MinSizeRestrictionEnabled) {
                        this.validateSize();
                        let minPos = this.getMinPositions();
                        if (Y > 0)
                            Y = 0;
                        else if (Y < minPos.Y)
                            Y = minPos.Y;
                        if (X > 0)
                            X = 0;
                        else if (X < minPos.X)
                            X = minPos.X;
                    }
                    return { X, Y };
                }
                SaveCurrentPosition(fromMouseUp = false) {
                    let pos = CS.Point.FromJQueryCoordinates(this.$Img.position());
                    //console.info("SaveCurrentPosition " + pos.X + ", " + pos.Y);
                    if (fromMouseUp && this.MinSizeRestrictionEnabled) {
                        CS.Lag("image-cropper-saveCurrentPositionTimer", 0, () => {
                            let newPos = this.validateNewPosition(pos);
                            if (newPos.Y != pos.Y || newPos.X != pos.X) {
                                pos = newPos;
                                this.setImagePosition(newPos);
                                this.inAnimation = false;
                            }
                        });
                    }
                    else
                        this.currentPosition = pos;
                    this.saveContainerSize();
                    //if (fromMouseUp) //This is to prevent bug when many small drag.
                    //    Lag("SavePositionSafe", 500, () => {
                    //        this.SaveCurrentPosition(false);
                    //    });
                }
                saveContainerSize() {
                    this.ContainerSize = new CS.Size(this.container.innerWidth(), this.container.innerHeight());
                }
                SaveOriginalSize() {
                    this.OriginalSize = new CS.Size(this.ImgHtml.naturalWidth, this.ImgHtml.naturalHeight);
                    this.saveContainerSize();
                }
                SaveMinSize() {
                    this.saveContainerSize();
                    this.MinSize = ImageCropperPopup.GetMinSize(this.OriginalSize, this.ContainerSize, this.MinSizeRestrictionEnabled);
                }
                Fit() {
                    let minSize = this.MinSize;
                    let marginLeft = -(minSize.Width / 2);
                    let marginTop = -(minSize.Height / 2);
                    //Resize and center the element;
                    this.$Img.css({
                        width: minSize.Width + "px",
                        height: minSize.Height + "px",
                        //left: 0 + 'px',
                        //right: 0 + 'px'
                        //left: '50%',
                        //top: '50%',
                        //marginLeft: marginLeft + 'px',
                        //marginTop: marginTop + 'px'
                    });
                    // Keep the whole image centered when empty space around it is allowed.
                    this.setImagePosition(this.MinSizeRestrictionEnabled ? { X: 0, Y: 0 } : {
                        X: (this.ContainerSize.Width - minSize.Width) / 2,
                        Y: (this.ContainerSize.Height - minSize.Height) / 2,
                    });
                    //this.marginLeft = marginLeft;
                    //this.marginTop = marginTop;
                    this.CurrentSize = minSize;
                    ImageCropperPopup.SaveScale(this.$Img);
                }
                Scale(scale, center) {
                    // A narrow image may need less than 100px of width to fit completely.
                    let minWidth = this.MinSizeRestrictionEnabled ? 100 : Math.min(100, this.MinSize.Width);
                    if (scale * this.OriginalSize.Width < minWidth) {
                        scale = minWidth / this.OriginalSize.Width;
                    }
                    let newWidth = scale * this.OriginalSize.Width;
                    let newHeight = scale * this.OriginalSize.Height;
                    let allowScale = true;
                    if (this.MinSizeRestrictionEnabled) {
                        if (newWidth < this.ContainerSize.Width ||
                            newHeight < this.ContainerSize.Height)
                            allowScale = false;
                        //if (newWidth + this.currentPosition.X < this.ContainerSize.Width || newHeight + this.currentPosition.Y < this.ContainerSize.Height)
                        //    allowScale = false;
                    }
                    if (allowScale) {
                        // The pinch center and image position are relative to the crop space.
                        // Use the applied size (after limits), so the image point under the
                        // fingers stays fixed even when the minimum width is reached.
                        const position = this.$Img.position();
                        const previousWidth = this.$Img.width();
                        const previousHeight = this.$Img.height();
                        this.CurrentSize = new CS.Size(newWidth, newHeight);
                        this.$Img.css({
                            width: newWidth + "px",
                            height: newHeight + "px",
                        });
                        if (center != null && previousWidth > 0 && previousHeight > 0) {
                            this.setImagePosition({
                                X: center.X - (center.X - position.left) * newWidth / previousWidth,
                                Y: center.Y - (center.Y - position.top) * newHeight / previousHeight,
                            });
                        }
                        //let delta: CS.IPoint = {
                        //    X: (newWidth - this.OriginalSize.Width) / 2,
                        //    Y: (newHeight - this.OriginalSize.Height) / 2
                        //};
                        //this.SetNewPosition(delta, false);
                    }
                    return allowScale;
                }
                getContainerMargin() {
                    let contLeftMargin = parseInt(this.container.css("margin-left").replace("px", ""));
                    let contTopMargin = parseInt(this.container.css("margin-top").replace("px", ""));
                    return { left: contTopMargin, top: contTopMargin };
                }
                SetNewPosition(delta, useAnimationFrame = true) {
                    let me = this;
                    //Important de fixer la variable parce que sinon, la valeur currentPosition aura changé
                    //suite au timeout et ainsi, la position ne sera pas accurate
                    //console.info("SetNewPosition " + me.currentPosition.X + ", " + me.currentPosition.Y + " delta " + delta.X + ", " + delta.Y);
                    let currentPos = me.currentPosition;
                    var animAction = () => {
                        if (!me.inAnimation)
                            return;
                        let newPosition = {
                            X: currentPos.X + delta.X,
                            Y: currentPos.Y + delta.Y,
                        };
                        me.setImagePosition(newPosition, false);
                        this.inAnimation = false;
                    };
                    if (!this.inAnimation) {
                        this.inAnimation = true;
                        if (!useAnimationFrame)
                            animAction();
                        else
                            window.requestAnimationFrame(animAction);
                    }
                    //clearTimeout(me.timer);
                    //me.timer = setTimeout(, 0);
                }
            }
        })(ImageCropperAddons = Controls.ImageCropperAddons || (Controls.ImageCropperAddons = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=image-cropper-popup.js.map
